import { actionCreator } from '@ardoq/rxbeach';
import { SurveyRow } from 'components/AssetsBrowser/types';

export type SurveyWorkspaceAccessRequestData = {
  survey?: SurveyRow;
  user: {
    name?: string | null;
    email?: string | null;
  };
};

export type SurveyAccessRequestData = SurveyWorkspaceAccessRequestData;

export const issueSurveyWorkspaceAccessRequest =
  actionCreator<SurveyWorkspaceAccessRequestData>(
    '[entityBrowserAtoms] ISSUE_SURVEY_WORKSPACE_ACCESS_REQUEST'
  );

export const resetSurveyWorkspaceAccessRequestState = actionCreator(
  '[entityBrowserAtoms] RESET_SURVEY_WORKSPACE_ACCESS_REQUEST_STATE'
);

export const setSurveyWorkspaceAccessRequestLoading = actionCreator<boolean>(
  '[entityBrowserAtoms] SET_SURVEY_WORKSPACE_ACCESS_REQUEST_LOADING'
);

export const setSurveyWorkspaceAccessRequestSent = actionCreator<boolean>(
  '[entityBrowserAtoms] SET_SURVEY_WORKSPACE_ACCESS_REQUEST_SENT'
);

export const issueSurveyAccessRequest = actionCreator<SurveyAccessRequestData>(
  '[entityBrowserAtoms] ISSUE_SURVEY_ACCESS_REQUEST'
);

export const resetSurveyAccessRequestState = actionCreator(
  '[entityBrowserAtoms] RESET_SURVEY_ACCESS_REQUEST_STATE'
);

export const setSurveyAccessRequestLoading = actionCreator<boolean>(
  '[entityBrowserAtoms] SET_SURVEY_ACCESS_REQUEST_LOADING'
);

export const setSurveyAccessRequestSent = actionCreator<boolean>(
  '[entityBrowserAtoms] SET_SURVEY_ACCESS_REQUEST_SENT'
);
